module.exports = __webpack_public_path__ + "img/pr-1.7d012865.png";